import { Fragment, useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import moment from "moment";
import {
  Modal,
  Table,
  Input,
  DatePicker,
  Tabs,
  notification,
  Alert,
} from "antd";
import { TableOptions } from "components";
//import Icons from "../../../../../../components/Icons";
import { usePaggination, useSecurity, useStatusLeadColor } from "../../../../../../config/hooks";

import { teamAnnouncementsListSearch, reset } from "./redux/slice";
import Filters from "../../../../../../components/Filters";
import {
  openStatusChangesHistory,
} from "../../../../.config/redux/actions";
import { Link } from "react-router-dom";
import ChangeStatus from "../../components/changeStatus";
import StatusChangesHistory from "../../modals/statusChangesHistory";
import {
  //P_ANNOUNCEMENT_CONTRACTS,
  P_TEAM_LEADS_EMAIL_WAS_OPENNED_COLUMN,
  P_TEAM_LEADS_STATUS_TABS,
  P_TEAM_LEADS_STATUS_COLUMN,
  P_TEAM_LEADS_LASTNOTE_COLUMN,
  P_TEAM_LEADS,
  //P_TEAM_LEADS_UPDATE_ANNOUNCEMENT_STATUS,
} from "../../../../../../config/helpers/permissionsHash";
import { TextDescriptionCompanies } from "../../../../../../components/TextDescriptionCompanies";
import TooltipList from "../../../../../../components/TooltipList";
import { calculateTime } from "../listAgent";
import { detailNoteOpen } from "../../modals/announcementNoteDetail/redux/slice";
import { RenderAnswersForm } from "../../../../../../components/RenderAnwsersForm";
import AnnouncementNoteDetail from "../../modals/announcementNoteDetail";


const CompanyAnnouncementsListView = () => {
  const dispatch = useDispatch();
  const { messages } = useIntl();
  const navigate = useNavigate();

  const [announcementStatusList, getDetailStatusColor] = useStatusLeadColor();

  const paggination = usePaggination(teamAnnouncementsListSearch);

  const { user } = useSelector((state) => state.authRedux);
  const { data, loading, error } = useSelector(
    (state) => state.teamAnnouncementsListRedux
  );

  const [currentTab, setCurrentTab] = useState(0);
  const [openDescModal, setOpenDescModal] = useState({
    author: "",
    date: "",
    text: "",
    isOpen: false,
  });

  const R = useSecurity(P_TEAM_LEADS, ["R"]);
  //const pChangeStatus = useSecurity(P_TEAM_LEADS_UPDATE_ANNOUNCEMENT_STATUS);
  const pShowHasOpennedCol = useSecurity(
    P_TEAM_LEADS_EMAIL_WAS_OPENNED_COLUMN
  );
  const pShowStatusCol = useSecurity(P_TEAM_LEADS_STATUS_COLUMN);
  const pShowLastNoteCol = useSecurity(P_TEAM_LEADS_LASTNOTE_COLUMN);
  const pStatusTabsCol = useSecurity(P_TEAM_LEADS_STATUS_TABS);
  //const PManageContractsRead = useSecurity(P_ANNOUNCEMENT_CONTRACTS, ["R"]);

  useEffect(() => {
    if (error) {
      notification.error({
        message: messages["saveError"]?.toString(),
        description: messages[error] || error.message,
      });
      dispatch(reset({"error": null}));
    }
  }, [error]);

  useEffect(() => {
      refresh();
  }, []);

  const refresh = () => {
    paggination.refresh()
  }

  const toggleOpenDescModal = (values = {}) => {
    setOpenDescModal({
      ...values,
      author: values?.author,
      date: values?.date,
      text: values?.text,
      isOpen: values?.isOpen,
    });
  };

  const tabsContent = useMemo(() => {
    const count = data?.countByStatus || {};
    const labelContent = (v) => (
      <span className="d-flex align-center">
        <div className="text-wrap" style={{ width: '7rem' }}>
          {v.name}
        </div>
        {count[v.id] != null && count[v.id] != 0 && (
          <span className="d-inline-flex ps-2 align-items-center ml-2">
            <span className="badge bg-secondary rounded-circle text-white d-flex justify-content-center align-items-center" style={{ width: '25px', height: '25px' }}>
              {count[v.id]}
            </span>
          </span>
        )}
      </span>
    );
    return [
      { key: 0, label: messages["all"], children: "" },
      ...announcementStatusList.map((v) => ({
        key: v.id,
        label: labelContent(v),
        children: "",
      })),
    ]
  }, [data])

  let columns = [
    {
      width: 10,
      render: (values) => {
        return (<TableOptions options={[
          {
            show: R,
            label: messages["view"],
            onClick: () => {
              navigate(
                `/admin/client/dashboard/team/detail/${values?.announcementId}`
              );
            },
          },
        ]} />)
      },
    },
    {
      title: messages["dashboardList_team_announcementCode"],
      key: "announcementId",
      dataIndex: "announcementId",
      width: 200,
      render: (row, values) => {
        const pa = values?.restrictionAccess?.affiliatedPartners.filter(v => v.hasAccess != 0).length;
        const ag = values?.restrictionAccess?.agents.filter(v => v.hasAccess != 0).length;
        const am = values?.restrictionAccess?.areaManagers.filter(v => v.hasAccess != 0).length;
        return (<div className="text-center">
          <Link
            target="blank"
            to={`/admin/client/dashboard/team/detail/${values?.announcementId}`}
          >
            {row}
          </Link>
          <hr />
          {user?.isAdmin && values?.restrictionAccess && <div className="text-start">
            <span>
              <TooltipList list={values?.restrictionAccess?.areaManagers.filter(v => v.hasAccess !== 0).map(v => v.fullName)}>
                {am > 1? <strong className="text-danger">Area Manager ({am})<i className="icon-base bx bx-error icon-md"/></strong>: `Area Manager (${am})` }
              </TooltipList>
            </span><br/>
            <span>
              <TooltipList list={values?.restrictionAccess?.agents.filter(v => v.hasAccess != 0).map(v => v.fullName)}>
                {ag > 1? <strong className="text-danger">Agenti ({ag})<i className="icon-base bx bx-error icon-md"/></strong>: `Agenti (${ag})` }
              </TooltipList>
            </span><br/>
            <span>
              <TooltipList list={values?.restrictionAccess?.affiliatedPartners.filter(v => v.hasAccess !== 0).map(v => v.company.name)}>
              {pa > 1? <strong className="text-danger">Partner Affiliati ({pa})<i className="icon-base bx bx-error icon-md"/></strong>: `Partner Affiliati (${pa})` }
              </TooltipList>
            </span><br/>
          </div>}
        </div>
      )},
    },
    {
      title: messages["dashboardList_announcementDate"],
      key: "createdOn",
      width: 200,
      //dataIndex: "createdOn",
      render: (row) =>
        row?.createdOn && moment(row.createdOn).format("DD/MM/yyyy HH:mm"),
    },
    {
      title: messages["dashboardList_announcementTitle"],
      key: "announcement",
      dataIndex: "announcement",
      render: (row) => row?.product,
    },
    {
      show: pShowStatusCol,
      title: messages["dashboardList_status"],
      key: "Status",
      dataIndex: "status",
      width: 200,
      render: (value, row) => {
        const _status = getDetailStatusColor(value, row?.substatus);
        const substatusLabel = _status?.substatusName || '';
        return (
          <div
            className={`flex-column full-cell-table text-center justify-content-around`}
            //
            style={{ cursor: "pointer", backgroundColor: _status.backgroundColor, color: _status.textColor }}
            onClick={() => {
              dispatch(
                openStatusChangesHistory({ companyAnnouncementId: row.id, typeAnnouncement: 'TEAM' })
              );
            }}
          >
            <h6 className="mb-2" style={{ fontSize: 16 }}>
              {`${value ? announcementStatusList?.find(v => value == v.id)?.name : 'avvia il cambiamento di stato'}`}
            </h6>
            {substatusLabel &&
              <b><a
                onClick={() => {
                  row?.lastStatusDetailNoteId && dispatch(detailNoteOpen({ announcementNoteId: row.lastStatusDetailNoteId }))
                }}>
                {substatusLabel.length > 50
                  ? `${substatusLabel.substring(0, 50)}...`
                  : substatusLabel}
              </a></b>}
            <h6 className="mb-0" style={{ fontSize: 14, color: _status.textColor }}>{row?.updatedStatus?.updatedBy.fullName}</h6>
            <p className="pt-3 text-right" style={{ fontSize: 14, width: '100%', marginRight:'-15px', textAlign: 'right' }}><b>{row?.updatedOn ? calculateTime(row?.updatedStatus?.updatedOn) : ''} </b></p>
          </div>
        );
      },
    },
    {
      title: messages["dashboardList_announcementAuthor"],
      key: "author",
      width: 200,
      //dataIndex: "announcement",
      render: (values) =>
        <div className="d-flex justify-content-start align-items-center">
          <div className="w-50">
            <a>{`${values?.announcement?.name} ${values?.announcement?.surname} `} </a>
          </div>
        </div>
    },
    {
      show: pShowLastNoteCol,
      title: messages["dashboardList_lastNote"],
      key: "lastNote",
      width: 250,
      //dataIndex: "lastNoteDate",
      render: (row) => (
        <div>
          <p>
            {row?.lastNote?.createdOn &&
              moment(row.lastNote?.createdOn).format("DD/MM/yyyy HH:mm")}
          </p>
          <p> di {row?.numberNotes} note totali </p>
        </div>
      ),
    },
    {
      show: pShowLastNoteCol,
      width: 200,
      title: messages["dashboardList_lastNoteDescription"],
      key: "lastNoteDescription",
      render: (values) => (
        <div>
          {values?.lastNote?.note && (
            <>
              <p className="table-text-overflow">
                {values?.lastNote?.note}
              </p>
              <a
                className="link-primary"
                onClick={() => toggleOpenDescModal({
                  ...values?.lastNote,
                  author: values?.lastNote?.created.firstName + ' ' + values?.lastNote?.created.lastName,
                  date: values?.lastNote?.createdOn,
                  text: values?.lastNote?.note,
                  isOpen: true,
                })}
              >
                {messages["dashboardList_seeMore"]}
              </a>
              <div>
                {
                  `${values?.totalProgrammedNotes.total} Promemoria `
                }
                <br />
                {`${values?.totalProgrammedNotes.totalSent} Inviati ( ${values?.totalProgrammedNotes.totalSentByAgents} Altri -  ${values?.totalProgrammedNotes.totalSentByAdmin} Admins )`
                }
                <br />
                {
                  `
                   ${values?.totalProgrammedNotes.totalPending} In attessa ( ${values?.totalProgrammedNotes.totalPendingByAgents} Altri -  ${values?.totalProgrammedNotes.totalPendingByAdmins} Admins )
                  `
                }
              </div>
            </>
          )}
        </div>
      ),
    },
    {
      show: pShowHasOpennedCol,
      key: "status",
      width: 50,
      render: (values) => {
        if (values?.totalProgrammedNotes.totalPending > 0) {
          return <Alert
            message={messages["listNotificacionStatusPending"]}
            type={"warning"}
            showIcon
          />
        } else {
          return
        }
      }
    },
  ];

  columns = columns.filter((v) => v?.show === undefined || v?.show);

  return (
    <Fragment>
      <div className="container-fluid flex-grow-1 container-p-y">
        <div className="card card-body">
          <div className="row">
            <div className="col-md-4 col-sm-12">
              {R && (
                <Input
                  type="text"
                  className="form-control my-1 w-100"
                  placeholder={messages["search"]}
                  onChange={paggination.onSearchChange}
                  value={paggination.searchText}
                />
              )}
            </div>
            <div className="col-md-8 col-sm-12">
              {R && (
                <div className="text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-md-end justify-content-center flex-wrap">
                  <Filters
                    width={300}
                    onApply={(values) => {
                      paggination.refresh(null, null, {
                        ...values,
                        statusId: currentTab,
                      });
                    }}
                  >
                    <Filters.Item
                      name="filterSendDate"
                      label={messages["campaignsList_date"]}
                    >
                      <DatePicker.RangePicker placement="bottomRight" />
                    </Filters.Item>
                  </Filters>
                  <button
                    className="btn btn-primary m-1"
                    onClick={() => {
                      paggination.refresh();
                    }}
                  >
                    {messages["refresh"]}
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="col-md-8 col-sm-12 mt-4 mb-4">
            <TextDescriptionCompanies />
          </div>

          <div className="mt-4 table-responsive">
            {pStatusTabsCol && (
              <Tabs
                size="small"
                type="card"
                onChange={(c) => {
                  paggination.refresh(null, null, {  statusId: c });
                  setCurrentTab(c);
                }}
                items={tabsContent}
              />
            )}
            {R && (
              <Table
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={data?.items || []}
                pagination={{
                  total: data?.count || 0,
                  ...paggination.tablePaggination,
                }}
              />
            )}
          </div>
        </div>
      </div>
      <StatusChangesHistory
        refresh={() => {
          paggination.refresh(null, null, {
            statusId: currentTab,
          });
        }}

      />
      <ChangeStatus.Modal
        refresh={() => {
          paggination.refresh(null, null, {
            statusId: currentTab,
          });
        }}
      />
      <AnnouncementNoteDetail />
      <Modal
        open={openDescModal.isOpen}
        width={800}
        onCancel={() => {
          toggleOpenDescModal({
            isOpen: false,
          });
        }}
        footer={null}
        maskClosable={false}
      >
        <div className="p-3 p-md-5">
          <h3>{openDescModal.author}</h3>
          <p>{moment(openDescModal.date).format("DD/MM/yyyy HH:mm")}</p>
          {openDescModal?.form ?
            <div>
              <RenderAnswersForm answers={openDescModal?.formAnswer} form={openDescModal?.form} />
            </div> :
            <p>{openDescModal.text}</p>
          }
        </div>
        <div className="row pt-2 ">
          <div className="col-12 text-center">
            <button
              className="btn btn-label-secondary"
              onClick={() => toggleOpenDescModal({
                isOpen: false,
              })}
            >
              {messages["close"]}
            </button>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default CompanyAnnouncementsListView;
